import { createHashRouter, Navigate, RouterProvider } from "react-router";

import { RequireSession } from "../auth/RequireSession";
import { HomeGrid } from "../layout/HomeGrid";
import { ModuleShell } from "../layout/ModuleShell";
import { Login } from "../pages/Login";

// Hash routing keeps the app a plain static bundle on OSS/CDN: no path
// rewriting is needed for deep links such as /#/m/candidates.
const router = createHashRouter([
  { path: "/login", element: <Login /> },
  { path: "/", element: <RequireSession><HomeGrid /></RequireSession> },
  { path: "/m/:module", element: <RequireSession><ModuleShell /></RequireSession> },
  { path: "*", element: <Navigate to="/" replace /> }
]);

export function App() {
  return <RouterProvider router={router} />;
}
